import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { fmtSigned } from "@/lib/format";

const TONES = {
  sage: "bg-[#8AA090]/15 text-[#4E6656]",
  terra: "bg-[#E07A5F]/12 text-[#A2513C]",
  gold: "bg-[#CBA368]/18 text-[#8A6A33]",
  blush: "bg-[#E8C5C8]/45 text-[#77594E]",
  plum: "bg-[#7F6A93]/12 text-[#5D4C6E]",
};

export const KpiCard = ({ testId, label, value, delta, deltaSuffix = "%", prevLabel, icon: Icon, tone = "sage", invert = false, sub, delay = 0 }) => {
  const good = delta == null ? null : invert ? delta <= 0 : delta >= 0;
  const Arrow = delta != null && delta < 0 ? ArrowDownRight : ArrowUpRight;
  return (
    <div data-testid={testId} style={{ animationDelay: `${delay}ms` }} className="card-soft p-5 sm:p-6 fade-up hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start justify-between gap-3">
        <span className="overline-label !text-[#756B64]">{label}</span>
        {Icon && (
          <span className={`h-9 w-9 rounded-full grid place-items-center shrink-0 ${TONES[tone]}`}>
            <Icon className="h-4 w-4" strokeWidth={1.8} />
          </span>
        )}
      </div>
      <div data-testid={`${testId}-value`} className="mt-3 text-2xl sm:text-[1.7rem] font-semibold tabular text-[#2C2623]">{value}</div>
      {delta !== undefined && (
        <div data-testid={`${testId}-delta`} className="mt-2 text-xs text-[#756B64] flex items-center gap-1.5 flex-wrap">
          {delta == null ? (
            <span>— nessun confronto</span>
          ) : (
            <span className={`inline-flex items-center gap-0.5 font-semibold ${good ? "text-[#4E7A5C]" : "text-[#B4553D]"}`}>
              <Arrow className="h-3.5 w-3.5" />
              {fmtSigned(delta, deltaSuffix)}
            </span>
          )}
          {prevLabel && delta != null && <span>vs {prevLabel}</span>}
        </div>
      )}
      {sub && <div className="mt-1 text-xs text-[#756B64]">{sub}</div>}
    </div>
  );
};
